var app = window.app || {};

// Global libraries
require('../lib/player/main')(document.createElement('audio'));

// --Basic
require('../lib/alerts/close-timer');

require('../lib/select2/init');
$(document).trigger('init.select2');

require('../lib/select-dropdown-init');
app = require('../lib/show-password')(app);

// --Notifications
app = require('../lib/notifications/load')(app);
app = require('../lib/notifications/check-all')(app);
app = require('../lib/notifications/submit')(app);

// --Form labels
app = require('../lib/form-labels/change')(app);
app = require('../lib/form-labels/load')(app);

// --Order history
app = require('../lib/order-history/initialize')(app);

window.app = app;

$(document).on('change', 'input:file', function() {
    'use strict';

    var input = $(this);
    var path = input.val().split('\\').pop();
    var pathInput = input.siblings('.input-group').find('.path-input');

    pathInput.val(path);
});
